import { useSiteConfig } from "@/contexts/SiteConfigContext";
import { PILL_BADGE_BASE } from "@/lib/pillBadge";

/** Compact BETA pill for headers and inline labels. */
export function BetaBadge({ className = "" }) {
    const { betaModeEnabled } = useSiteConfig();
    if (!betaModeEnabled) return null;

    return (
        <span
            className={`${PILL_BADGE_BASE} border-[#00BF0D]/30 bg-[#00BF0D]/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.16em] text-[#00BF0D] ${className}`}
            data-testid="beta-badge"
        >
            Beta
        </span>
    );
}
/** Dashboard-level notice when beta mode is active. */
export function BetaModeNotice({ className = "" }) {
    const { betaModeEnabled } = useSiteConfig();
    if (!betaModeEnabled) return null;

    return (
        <div
            className={`beta-mode-notice rounded-xl border border-[#00BF0D]/20 bg-[#00BF0D]/[0.05] px-4 py-3.5 ${className}`}
            data-testid="beta-mode-notice"
        >
            <div className="flex flex-wrap items-center gap-2.5 fs-pill-anchor">
                <BetaBadge />
                <p className="text-sm font-medium leading-none text-white/90">FairShare is currently in beta</p>
            </div>
            <p className="mt-2.5 text-xs leading-relaxed text-white/55">
                Features may change, and you may encounter rough edges. We appreciate your feedback while we refine the platform.
            </p>
        </div>
    );
}
